import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import {
  FormConfig,
  FormField,
  IFormComponent,
  IFormConfig,
  IFormField,
} from '@models/form/form';
import { IInputField, InputField } from '@models/form/input';

@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  // TODO: This is set to the default change detection for now to show validation messages correctly. Switch back when possible.
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FormInputComponent implements IFormComponent<IInputField> {
  public config: IFormField<IInputField> = new FormField<IInputField>({
    fieldConfig: new InputField(),
  });
  public formConfig: IFormConfig = new FormConfig();
  public group: UntypedFormGroup = new UntypedFormGroup({});

  public get formControl(): AbstractControl {
    return this.group.get(this.config.name);
  }
}
